import { createLazyComponent } from '../utils/LazyWrapper';

const RequestFlightForm = createLazyComponent(() => import('../components/organisms/RequestFlightForm/indexWrapper'));
RequestFlightForm.displayName = 'EmRequestFlightForm';
export default RequestFlightForm;